import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import TopStories from '../components/sections/TopStories';
import ServicesSection from '../components/sections/ServicesSection';
import AboutSection from '../components/sections/AboutSection';
import SiteFooter from '../components/sections/SiteFooter';
import SubmitTipButton from '../components/SubmitTipButton';
import TopNav from '../components/sections/TopNav';
import InstallPrompt from '../components/sections/InstallPrompt';
import CollapsibleSection from '../components/sections/CollapsibleSection';
import NotificationsPrompt from '../components/sections/NotificationsPrompt';
import TipWallShowcase from '../components/sections/TipWallShowcase';
import FoundingCountdownTicker from '../components/FoundingCountdownTicker';
import HomeFoundersPreview from '../components/sections/HomeFoundersPreview';
import HomeVoicemailCard from '../components/sections/HomeVoicemailCard';
import AdSlot from '../components/AdSlot';
import { ensureServiceWorker } from '../utils/push';
import { useJsonLd, ORG_JSONLD, WEBSITE_JSONLD } from '../utils/jsonLd';
import { useSeoMeta } from '../utils/jsonLd';
import { PAGE_SEO } from '../utils/pageSeo';

const Home = () => {
  const navigate = useNavigate();
  useJsonLd(ORG_JSONLD, 'org');
  useJsonLd(WEBSITE_JSONLD, 'website');
  useSeoMeta({ ...PAGE_SEO.home, type: 'website' });

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track/pageview`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        url: window.location.href,
        referrer: document.referrer || null,
      }),
    }).catch((err) => console.error('Failed to track page view:', err));
    ensureServiceWorker().catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-black text-white" data-testid="home-page">
      <TopNav />

      {/* Featured stories carousel - pulls from local /api/articles */}
      <TopStories />

      {/* Founding countdown - scarcity strip so visitors see the 80-place
          cap before they reach /subscribe. Clicking sends them straight to
          the pricing grid. */}
      <div className="max-w-4xl mx-auto px-4 pt-6 pb-2" data-testid="home-founding-ticker">
        <FoundingCountdownTicker onClaimClick={() => navigate('/subscribe')} />
      </div>

      {/* Social proof: the last three engraved Founder plates. Renders null
          until at least one founder is on the wall. */}
      <HomeFoundersPreview />

      {/* Voicemail entry point - many readers won't type but will talk. */}
      <HomeVoicemailCard />

      {/* Public tip board preview */}
      <TipWallShowcase />

      <AdSlot slotId="home-mid" className="pt-1 pb-4" />

      {/* Everything below is context - collapsed by default so it doesn't slow
          returning readers from getting to the story they want. */}
      <CollapsibleSection previewHeight={140} label="See What We Deliver" testId="services-collapsible">
        <ServicesSection />
      </CollapsibleSection>
      <AboutSection />

      <AdSlot slotId="home-bottom" className="pt-4 pb-6" />
      <SiteFooter />
      <SubmitTipButton />
      <InstallPrompt />
      <NotificationsPrompt />
    </div>
  );
};

export default Home;
